import { filterReducer } from './filterReducer.js';
import { displayPreferenceReducer } from './displayPreferenceReducer.js';
import { measurementUnitReducer } from './measurementUnitReducer.js';
import { ringMeasurementTypeReducer } from './ringMeasurementTypeReducer.js';

export const sbSharedReducers = {
    filters: filterReducer,
    displayPreferences: displayPreferenceReducer,
    measurementUnit: measurementUnitReducer,
    ringMeasurementType: ringMeasurementTypeReducer,
};
